// src/components/ShoppingList/CalendarModal.tsx
import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { enGB } from 'date-fns/locale/en-GB';
import 'react-datepicker/dist/react-datepicker.css';
import BottomSheet from '../Shared/BottomSheet';
registerLocale('en-GB', enGB);

type DateRange = {
  startDate: string;
  endDate: string;
};

type CalendarModalProps = {
  isOpen: boolean; // ← new
  onSelectRange: (range: DateRange) => void;
  onClose: () => void;
};

const CalendarModal: React.FC<CalendarModalProps> = ({
  isOpen,
  onSelectRange,
  onClose,
}) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleRangeChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleSubmit = () => {
    if (startDate && endDate) {
      onSelectRange({
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString(),
      });
      onClose();
    }
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <h2 className="mb-4 text-lg font-semibold">
        Time period for the shopping list
      </h2>
      <div className="p-4 w-80 mx-auto">
        <div className="flex justify-center">
          <DatePicker
            selected={startDate}
            onChange={handleRangeChange}
            startDate={startDate}
            endDate={endDate}
            selectsRange
            inline
            calendarClassName="custom-calendar"
            locale="en-GB"
          />
        </div>
        <div className="mt-4 flex justify-center">
          <button
            onClick={handleSubmit}
            disabled={!(startDate && endDate)}
            className={`
              px-4 py-2 rounded-full text-white text-sm
              ${
                startDate && endDate
                  ? 'bg-primary hover:bg-primary/90'
                  : 'bg-primary/50 cursor-not-allowed'
              }
            `}
          >
            OK
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CalendarModal;
